import { BorderedContainer } from '../../../common/BorderedContainer';
import { convertToPresenceAbsence } from '../../../common/converters';
import { SectionTitle } from '../../../common/SectionTitle';
import { InfoDisplay } from '../../common/InfoDisplay';
import { IncidentDetailPatient } from 'sections/niigata/features/IncidentDetail/useIncidentDetailForNiigata';

type Props = {
  /** 実施基準。 */
  operationCriteria: IncidentDetailPatient['operationCriteria'];
};

/** 実施基準のコンポーネント。 */
export const OperationCriteria = ({ operationCriteria }: Props) => {
  return (
    <BorderedContainer>
      <div className="flex flex-col gap-[24px]">
        <SectionTitle text="実施基準" />
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          {operationCriteria ? (
            <>
              <InfoDisplay
                title="実施基準"
                content={convertToPresenceAbsence(
                  operationCriteria.operationCriteria
                )}
              />
              <InfoDisplay
                title="対象"
                content={operationCriteria.operationCriteriaDetail ?? ''}
              />
            </>
          ) : (
            <EmptyField />
          )}
        </div>
      </div>
    </BorderedContainer>
  );
};

const EmptyField = () => (
  <>
    <InfoDisplay title="実施基準" content="" />
    <InfoDisplay title="対象" content="" />
  </>
);
